import { environnement } from '@/config/env';
import type { Identite } from '@/shared/donnees/types';

/** Le compartiment public des photos de profil (db/015-identite.sql). */
export const COMPARTIMENT_PHOTOS = 'photos-profil';

/**
 * L'adresse publique d'une photo de profil, d'après son chemin dans le
 * compartiment. Une adresse « data: » (accès libre) passe telle quelle.
 */
export function adressePhotoProfil(chemin: string | null | undefined): string | null {
  if (!chemin) return null;
  if (chemin.startsWith('data:')) return chemin;
  if (!environnement.ok || environnement.env.mode !== 'supabase') return null;
  const base = environnement.env.supabaseUrl.replace(/\/+$/, '');
  return `${base}/storage/v1/object/public/${COMPARTIMENT_PHOTOS}/${chemin
    .split('/')
    .map(encodeURIComponent)
    .join('/')}`;
}

export const LONGUEUR_MAX_IDENTITE = 60;

/** Le prénom et le nom, nettoyés ; lève une erreur lisible s'il en manque un. */
export function verifierIdentite(identite: Identite): Identite {
  const prenom = identite.prenom.trim().replace(/\s+/g, ' ');
  const nomFamille = identite.nomFamille.trim().replace(/\s+/g, ' ');
  if (!prenom) throw new Error('Indiquez le prénom.');
  if (!nomFamille) throw new Error('Indiquez le nom.');
  if (prenom.length > LONGUEUR_MAX_IDENTITE || nomFamille.length > LONGUEUR_MAX_IDENTITE) {
    throw new Error(`Le prénom et le nom tiennent en ${String(LONGUEUR_MAX_IDENTITE)} caractères.`);
  }
  return { prenom, nomFamille };
}

/** Un compte sans nom ne peut pas signer ses actions : il doit le saisir d'abord. */
export function identiteManquante(compte: { nom: string }): boolean {
  return compte.nom.trim() === '';
}

/** Le prénom et le nom d'un compte, à défaut de les avoir séparés : découpés au premier espace. */
export function identiteDe(compte: {
  nom: string;
  prenom?: string | undefined;
  nomFamille?: string | undefined;
}): Identite {
  if (compte.prenom || compte.nomFamille) {
    return { prenom: compte.prenom ?? '', nomFamille: compte.nomFamille ?? '' };
  }
  const nom = compte.nom.trim();
  const espace = nom.indexOf(' ');
  return espace < 0
    ? { prenom: nom, nomFamille: '' }
    : { prenom: nom.slice(0, espace), nomFamille: nom.slice(espace + 1).trim() };
}
